<nav class="bottom-nav">
  @if (hasLearnerRole) {
    <a
      class="nav-tab"
      routerLink="/assignments"
      [class.active]="isActive('/assignments', ['/assignment', '/learning-pathway'])"
    >
      {{ 'general.ASSIGNMENTS' | transloco }}
    </a>
  }
  <a
    class="nav-tab account-tab"
    routerLink="/ios-account"
    [class.active]="isActive('/ios-account')"
  >
    {{ 'general.ACCOUNT' | transloco }}
  </a>
</nav>
